export default __webpack_public_path__ + "static/media/NoRacesMascot.bf273eab.png";